import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class InspeccionService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: Http) {
        this.url = GLOBAL.url;
    }


    getTipoIngreso(){
        let headers = new Headers({
            'Content-Type': 'application/json',
        });


        console.log('Inspeccion Service', this.url);

        return this._http.get(this.url + 'tipoIngreso', { headers: headers })
            .pipe(map(res => res.json()));
    }


    crearInspeccion(data) {

        //console.log(data)
        let headers = new Headers({
            'Content-type': 'application/json',
        })

        return this._http.post(this.url + 'save/inspeccion', data, { headers: headers })
            .pipe(map(res => res.json()))
    }


}